import { DIMBO_CONSTANT } from './../utils/constant';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(private http: HttpClient, private router: Router) { }

    /*get call*/
    public get(url: string, options?: any) {
        const finalURL = DIMBO_CONSTANT.API_ENDPOINT + url;
        return this.http.get(finalURL, options);
    }

    /*post call*/
    public post(url: string, body: any, options?: any) {
        const finalURL = DIMBO_CONSTANT.API_ENDPOINT + url;
        return this.http.post(finalURL, body, options);
    }

    /*put call*/
    public put(url: string, body: any, options?: any) {
        const finalURL = DIMBO_CONSTANT.API_ENDPOINT + url;
        return this.http.put(finalURL, body, options);
    }

    /*delete call*/
    public delete(url: string, options?: any) {
        const finalURL = DIMBO_CONSTANT.API_ENDPOINT + url;
        return this.http.delete(finalURL, options);
    }

    /* prepare query params*/
    public prepareQueryParams(params: any): string {
        let queryParams = '?';
        for (const key in params) {
            //if (params[key] || params[key] === false) {
                let value = params[key]
                queryParams += key + '=' + value + '&';
            //}
        }
        queryParams = queryParams.substring(0, (queryParams.length - 1));
        return queryParams;
    }

    /*get query params*/
    public getUrlQueryParams(url: string): any {
        let params: any = undefined;
        let queryParamString = this.router.url.split('?')[1];
        if (queryParamString) {
            params = {};
            let queryParams = queryParamString.split('&');
            queryParams.forEach(param => {
                let obj = param.split('=');
                let key = obj[0];
                let value = obj[1];
                if (key && value) {
                    params[key] = value;
                }
            });
        }
        return params
    }

    // Method to call a GET request for Token API only
    public getCallForToken(url: string, token: any): Observable<any> { 
      let finalURL = DIMBO_CONSTANT.API_ENDPOINT + url;
      let options = {
        headers: {
            token: `bearer ${token}` ,
            'Content-Type': `application/json ; charset=utf-8` ,


        }
      }
      return this.http.get(finalURL, options);
    }

    public getWithOption(url: string, option: any):Observable<any>{
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        return this.http.get(url, {headers: headers});
    }

    public getWithObserve(url: string):Observable<any>{
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        return this.http.get(url,{headers: headers});
        
    }
    public getWithOptionVI(url: string, option: any):Observable<any>{
        return this.http.get(url,option);
    }

    /*put call*/
    public putWithObserve(url: string, body: any, options?: any) {
        return this.http.put(url, body, options);
    }

    /*POST call*/
    public postWithObserve(url: string, body: any, options?: any) {
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        return this.http.post(url, body, {headers: headers});
    }
/*POST call*/
public postWithObservSH(url: string, body: any, options?: any) {
    return this.http.post(url, body,options);
}
}
